import SAPOMailConfig        from "@/SAPOMailConfig";

export { DomControllerSingleton as default };

/**
* Dom controller
*
* Performs dom actions over cached html dom elements
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class DomController {
  /**
   * Caches DOM HTML Object
   *
   * @param {Object}
   *
   * @private
   *
   * @since 7.0.0
   */
  html;

  /**
   * Caches DOM Body Object
   *
   * @param {Object}
   *
   * @private
   *
   * @since 7.0.0
   */
  body;

  /**
   * Caches DOM HEAD Object
   *
   * @param {Object}
   *
   * @private
   *
   * @since 7.0.0
   */
  head;

  /**
   * Caches dom elements needed to work
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  load() {
    this.body             = document.body;
    this.html             = document.getElementsByTagName('html')[0];
  }

  /**
   * Adds a class to the DOM body element
   *
   * @since 7.0.0
   *
   * @param {String} value class value
   *
   * @return {void}
   */
  setBodyClass(value) {
    this.body.classList.add(value)
  }

  /**
   * Removes a class from the DOM body element
   *
   * @since 7.0.0
   *
   * @param {String} value class value
   *
   * @return {void}
   */
  removeBodyClass(value) {
    this.body.classList.remove(value)
  }

  /**
   * Sets Body fullscreen classe
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  setBodyFullScreen() {
    this.body.classList.add('body-fullscreen')
  }

  /**
   * Removes body fullscreen class
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  unsetBodyFullScreen() {
    this.body.classList.remove('body-fullscreen')
  }


  /**
   * Adds a class to the DOM HTML element
   *
   * @since 7.0.0
   *
   * @param {String} value class value
   *
   * @return {void}
   */
  setHTMLClass(value) {
    this.html.classList.add(value)
  }

  /**
   * Removes a class to the DOM HTML element
   *
   * @since 7.0.0
   *
   * @param {String} value class value
   *
   * @return {void}
   */
  removeHTMLClass(value) {
    this.html.classList.remove(value)
  }
}

const DomControllerSingleton = new DomController();